import type { Movie } from '@/types/movie';

export const movies: Movie[] = [
  {
    id: 'star-return',
    title: '星际归途',
    type: 'movie',
    year: 2025,
    region: '欧美',
    genres: ['科幻', '冒险', '剧情'],
    director: 'Elena Vasquez',
    actors: ['Miles Carter', 'Nora Bennett', 'David Okafor'],
    rating: 8.7,
    heat: 9850,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20lone%20astronaut%20silhouette%20floating%20before%20a%20glowing%20violet%20nebula%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20soft%20dark%20studio%20background%2C%20premium%20streaming%20poster%20art%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20dramatic%20lighting&width=400&height=600&seq=poster-mv01&orientation=portrait',
    summary: '一支深空补给船队在返航途中遭遇时空畸变，领航员必须在燃料耗尽前重新计算归途坐标，一场关乎文明存续的抉择就此展开。',
    updatedAt: '2025-09-28',
  },
  {
    id: 'changan-night',
    title: '长安夜行',
    type: 'movie',
    year: 2024,
    region: '大陆',
    genres: ['动作', '悬疑', '历史'],
    director: '沈砚舟',
    actors: ['陆骁', '江白露', '顾清和'],
    rating: 8.3,
    heat: 9120,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20an%20ancient%20Chinese%20warrior%20in%20dark%20robe%20holding%20a%20lantern%20on%20a%20rainy%20night%20street%2C%20deep%20navy%20and%20amber%20lantern%20glow%2C%20moody%20studio%20background%2C%20premium%20streaming%20poster%20art%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20lighting&width=400&height=600&seq=poster-mv02&orientation=portrait',
    summary: '长安城连续发生离奇命案，一名被贬的捕快与神秘女医联手追查，线索最终指向十年前的宫廷旧案。',
    updatedAt: '2024-11-15',
  },
  {
    id: 'deep-sea-echo',
    title: '深海回声',
    type: 'movie',
    year: 2023,
    region: '欧美',
    genres: ['科幻', '悬疑'],
    director: 'Jonas Reed',
    actors: ['Cara Whitfield', 'Tom Ashford', 'Iris Lang'],
    rating: 7.9,
    heat: 7640,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20deep%20sea%20submarine%20window%20with%20an%20eerie%20glowing%20signal%20in%20dark%20water%2C%20teal%20navy%20and%20amber%20accents%2C%20soft%20dark%20background%2C%20premium%20streaming%20poster%20art%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20atmospheric&width=400&height=600&seq=poster-mv03&orientation=portrait',
    summary: '深海科考站在海底收到一段无法解释的重复信号，随着调查深入，队员们发现信号可能来自他们自己。',
    updatedAt: '2023-08-02',
  },
  {
    id: 'farewell-rain',
    title: '雨夜告别',
    type: 'movie',
    year: 2024,
    region: '日韩',
    genres: ['爱情', '剧情'],
    director: '林知夏',
    actors: ['尹书妍', '南时宇', '崔恩'],
    rating: 8.1,
    heat: 6980,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20two%20lovers%20standing%20apart%20under%20one%20umbrella%20in%20soft%20rain%20at%20dusk%2C%20muted%20navy%20and%20warm%20amber%20tones%2C%20gentle%20blurred%20background%2C%20romantic%20streaming%20poster%20art%2C%20no%20text%2C%20tender%20mood&width=400&height=600&seq=poster-mv04&orientation=portrait',
    summary: '两个在异乡打拼的年轻人在雨夜相遇，又在另一个雨夜告别，一段跨越三年的遗憾之恋。',
    updatedAt: '2024-06-20',
  },
  {
    id: 'chasing-wind',
    title: '追风少年',
    type: 'movie',
    year: 2022,
    region: '大陆',
    genres: ['剧情', '青春'],
    director: '周牧',
    actors: ['陈亦航', '苏晓晓', '王大力'],
    rating: 7.6,
    heat: 5210,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20young%20cyclist%20sprinting%20on%20a%20coastal%20road%20at%20golden%20hour%2C%20deep%20blue%20sky%20and%20amber%20sun%2C%20clean%20minimal%20background%2C%20inspiring%20streaming%20poster%20art%2C%20highly%20detailed%2C%20no%20text%2C%20dynamic%20composition&width=400&height=600&seq=poster-mv05&orientation=portrait',
    summary: '小镇少年怀揣骑行梦想，在一次次跌倒与质疑中，用一场比赛证明了自己的坚持。',
    updatedAt: '2022-09-10',
  },
  {
    id: 'dark-alley',
    title: '暗巷迷局',
    type: 'movie',
    year: 2023,
    region: '港台',
    genres: ['犯罪', '悬疑'],
    director: '庄文杰',
    actors: ['何家豪', '林静仪', '郑立'],
    rating: 7.8,
    heat: 6120,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20detective%20in%20a%20trench%20coat%20walking%20through%20a%20neon%20lit%20narrow%20alley%20at%20night%2C%20navy%20and%20amber%20neon%20reflections%2C%20dark%20cinematic%20background%2C%20crime%20thriller%20poster%20art%2C%20no%20text%2C%20gritty%20mood&width=400&height=600&seq=poster-mv06&orientation=portrait',
    summary: '一名老刑警追查连环劫案，却发现每一条线索都指向自己曾经最信任的搭档。',
    updatedAt: '2023-12-01',
  },
  {
    id: 'dream-traveler',
    title: '梦境旅人',
    type: 'movie',
    year: 2025,
    region: '欧美',
    genres: ['奇幻', '冒险'],
    director: 'Sofia Lind',
    actors: ['Lucas Gray', 'Mia Delacroix', 'Owen Pike'],
    rating: 8.5,
    heat: 8930,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20dream%20traveler%20standing%20before%20a%20floating%20door%20in%20a%20surreal%20sky%20of%20drifting%20islands%2C%20deep%20navy%20and%20amber%20fantasy%20glow%2C%20soft%20dreamy%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20whimsical%20and%20detailed&width=400&height=600&seq=poster-mv07&orientation=portrait',
    summary: '能自由穿行他人梦境的女孩，为寻找失踪的哥哥，踏上了一场穿越层层梦境的奇幻旅程。',
    updatedAt: '2025-10-05',
  },
  {
    id: 'time-letter',
    title: '时光信笺',
    type: 'movie',
    year: 2021,
    region: '日韩',
    genres: ['爱情', '奇幻'],
    director: '田中美咲',
    actors: ['佐仓凛', '高桥悠', '森川葵'],
    rating: 7.7,
    heat: 4830,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20vintage%20wooden%20mailbox%20overflowing%20with%20letters%20under%20soft%20sunlight%2C%20warm%20amber%20and%20deep%20navy%20tones%2C%20quiet%20nostalgic%20background%2C%20romantic%20poster%20art%2C%20no%20text%2C%20gentle%20melancholy&width=400&height=600&seq=poster-mv08&orientation=portrait',
    summary: '一家老邮局能让信件寄往过去，女孩借此试图挽回一段已经结束的感情，却发现改变意味着失去。',
    updatedAt: '2021-05-18',
  },
  {
    id: 'cloud-city',
    title: '云上之城',
    type: 'tv',
    year: 2024,
    region: '大陆',
    genres: ['剧情', '悬疑', '都市'],
    director: '许清晏',
    actors: ['黎川', '温雨眠', '赵一鸣', '沈知微'],
    rating: 8.6,
    heat: 9640,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20tv%20drama%20poster%20of%20a%20futuristic%20city%20skyline%20above%20clouds%20with%20a%20single%20figure%20gazing%20out%2C%20deep%20navy%20and%20amber%20sunrise%20tones%2C%20clean%20minimal%20background%2C%20premium%20streaming%20poster%20art%2C%20no%20text%2C%20epic%20and%20detailed&width=400&height=600&seq=poster-tv01&orientation=portrait',
    summary: '在一座云端的科技新城，一群年轻人围绕一桩数据泄露案展开调查，逐渐揭开城市光鲜背后的秘密。',
    episodes: 36,
    updatedAt: '2025-09-30',
  },
  {
    id: 'throne-scheme',
    title: '权谋之巅',
    type: 'tv',
    year: 2023,
    region: '大陆',
    genres: ['历史', '剧情'],
    director: '萧远山',
    actors: ['陆霆', '秦书言', '公孙鹤', '叶清婉'],
    rating: 8.9,
    heat: 10240,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20historical%20drama%20poster%20of%20an%20ancient%20Chinese%20emperor%20with%20golden%20crown%20before%20a%20dramatic%20throne%20hall%2C%20deep%20navy%20and%20antique%20amber%20gold%2C%20soft%20dark%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20majestic%20and%20detailed&width=400&height=600&seq=poster-tv02&orientation=portrait',
    summary: '王朝更迭之际，寒门学子凭借过人才智卷入朝堂博弈，在权力的漩涡中守住初心。',
    episodes: 48,
    updatedAt: '2024-02-08',
  },
  {
    id: 'mist-detective',
    title: '迷雾侦探',
    type: 'tv',
    year: 2024,
    region: '欧美',
    genres: ['悬疑', '犯罪'],
    director: 'Harper Quinn',
    actors: ['Elliot Shaw', 'Rosa Vane', 'Nathan Cole'],
    rating: 8.4,
    heat: 8210,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20mystery%20series%20poster%20of%20a%20detective%20silhouette%20before%20a%20foggy%20forest%20with%20a%20single%20streetlight%2C%20deep%20navy%20and%20cool%20amber%20glow%2C%20soft%20misty%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20tense%20atmosphere&width=400&height=600&seq=poster-tv03&orientation=portrait',
    summary: '一座常年被浓雾笼罩的小镇接连发生失踪案，沉默的警探循着蛛丝马迹逼近被刻意掩埋的真相。',
    episodes: 10,
    updatedAt: '2025-08-16',
  },
  {
    id: 'spring-confession',
    title: '春日告白',
    type: 'tv',
    year: 2023,
    region: '日韩',
    genres: ['爱情', '青春'],
    director: '金雨真',
    actors: ['韩秀雅', '李道贤', '朴敏'],
    rating: 7.9,
    heat: 7340,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20romance%20series%20poster%20of%20a%20high%20school%20couple%20under%20blooming%20cherry%20blossoms%2C%20soft%20navy%20and%20warm%20amber%20pastel%20tones%2C%20airy%20clean%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20sweet%20and%20youthful&width=400&height=600&seq=poster-tv04&orientation=portrait',
    summary: '转学生与沉默的优等生因为一本共享的笔记相遇，在樱花盛开的一季里书写了一场青涩告白。',
    episodes: 16,
    updatedAt: '2023-05-22',
  },
  {
    id: 'homeland-past',
    title: '山河故人',
    type: 'tv',
    year: 2022,
    region: '大陆',
    genres: ['历史', '战争', '剧情'],
    director: '郑振国',
    actors: ['聂诚', '罗淑华', '白岩'],
    rating: 8.8,
    heat: 9180,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20war%20drama%20poster%20of%20a%20soldier%20overlooking%20a%20vast%20misty%20mountain%20range%20at%20dawn%2C%20deep%20navy%20and%20amber%20dust%20tones%2C%20epic%20soft%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20solemn%20and%20detailed&width=400&height=600&seq=poster-tv05&orientation=portrait',
    summary: '战火纷飞的年代，一个普通家庭三代人的命运与国家紧紧相连，书写了一部荡气回肠的家国史诗。',
    episodes: 40,
    updatedAt: '2022-10-01',
  },
  {
    id: 'urban-pulse',
    title: '都市脉动',
    type: 'tv',
    year: 2025,
    region: '大陆',
    genres: ['都市', '剧情'],
    director: '林一舟',
    actors: ['许南', '顾念', '江屿', '白露'],
    rating: 8.2,
    heat: 8760,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20urban%20drama%20poster%20of%20young%20professionals%20walking%20through%20a%20modern%20city%20at%20dusk%20with%20glowing%20windows%2C%20deep%20navy%20and%20amber%20city%20lights%2C%20clean%20minimal%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20modern%20and%20refined&width=400&height=600&seq=poster-tv06&orientation=portrait',
    summary: '四位在高楼里打拼的都市青年，在升职、失业与情感的拉扯中，重新寻找生活的重心。',
    episodes: 30,
    updatedAt: '2025-09-12',
  },
  {
    id: 'midnight-diner',
    title: '深夜食堂·东京',
    type: 'tv',
    year: 2024,
    region: '日韩',
    genres: ['剧情', '都市'],
    director: '小林和彦',
    actors: ['松本健', '中村绫', '山田翔'],
    rating: 8.3,
    heat: 6420,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20series%20poster%20of%20a%20cozy%20late%20night%20Japanese%20diner%20counter%20with%20warm%20hanging%20lanterns%2C%20deep%20navy%20night%20and%20amber%20warm%20glow%2C%20intimate%20soft%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20heartwarming%20mood&width=400&height=600&seq=poster-tv07&orientation=portrait',
    summary: '一间只在深夜营业的小食堂，用一道道家常菜串起都市旅人的悲欢心事。',
    episodes: 12,
    updatedAt: '2024-09-05',
  },
  {
    id: 'double-life',
    title: '双面人生',
    type: 'tv',
    year: 2022,
    region: '欧美',
    genres: ['悬疑', '剧情'],
    director: 'Grace Monroe',
    actors: ['Adam Frost', 'Lena Ortiz', 'Paul Reyes'],
    rating: 8.0,
    heat: 6890,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20thriller%20series%20poster%20of%20a%20man%20reflected%20in%20a%20mirror%20showing%20two%20different%20faces%2C%20deep%20navy%20and%20amber%20split%20lighting%2C%20dark%20minimal%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20intriguing%20and%20detailed&width=400&height=600&seq=poster-tv08&orientation=portrait',
    summary: '一位受到尊敬的社区医生被卷入一桩身份冒用案，他平静的双面人生即将被彻底揭开。',
    episodes: 8,
    updatedAt: '2022-07-30',
  },
  {
    id: 'running-starnight',
    title: '奔跑吧星夜',
    type: 'variety',
    year: 2025,
    region: '大陆',
    genres: ['真人秀', '竞技'],
    director: '陈立行',
    actors: ['何一凡', '苏黎', '郑小北', '林可'],
    rating: 8.1,
    heat: 8540,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20variety%20show%20poster%20of%20a%20group%20of%20energetic%20hosts%20running%20under%20night%20city%20lights%2C%20deep%20navy%20and%20vibrant%20amber%20accent%20colors%2C%20clean%20dynamic%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20fun%20and%20lively&width=400&height=600&seq=poster-vr01&orientation=portrait',
    summary: '明星嘉宾组成两支队伍，在城市地标之间展开趣味十足的夜跑竞技挑战。',
    episodes: 20,
    updatedAt: '2025-10-01',
  },
  {
    id: 'music-live',
    title: '音乐现场',
    type: 'variety',
    year: 2024,
    region: '大陆',
    genres: ['音乐'],
    director: '周慕云',
    actors: ['叶声', '林晚', '赵焱'],
    rating: 8.4,
    heat: 7210,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20music%20show%20poster%20of%20a%20singer%20on%20stage%20bathed%20in%20spotlight%20with%20silhouetted%20crowd%2C%20deep%20navy%20stage%20and%20amber%20spotlight%20tones%2C%20clean%20concert%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20electrifying%20mood&width=400&height=600&seq=poster-vr02&orientation=portrait',
    summary: '顶尖唱将与新声代歌者同台竞演，用一场场现场演唱重新定义舞台的魅力。',
    episodes: 15,
    updatedAt: '2024-11-20',
  },
  {
    id: 'comedy-king',
    title: '喜剧之王驾到',
    type: 'variety',
    year: 2025,
    region: '大陆',
    genres: ['喜剧', '真人秀'],
    director: '高大全',
    actors: ['马奔腾', '谢娜娜', '郭子'],
    rating: 7.8,
    heat: 7480,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20comedy%20show%20poster%20of%20colorful%20stage%20curtains%20and%20a%20microphone%20in%20warm%20spotlight%2C%20deep%20navy%20and%20playful%20amber%20accents%2C%20clean%20bold%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20humorous%20and%20bright&width=400&height=600&seq=poster-vr03&orientation=portrait',
    summary: '各路喜剧新秀同台比拼，用最贴近生活的段子博得全场笑声与观众投票。',
    episodes: 18,
    updatedAt: '2025-08-25',
  },
  {
    id: 'extreme-week',
    title: '极限挑战周',
    type: 'variety',
    year: 2024,
    region: '大陆',
    genres: ['竞技', '真人秀'],
    director: '孟航',
    actors: ['罗天', '白泽', '夏禾', '宋岩'],
    rating: 7.9,
    heat: 6980,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20adventure%20variety%20poster%20of%20a%20group%20of%20contestants%20standing%20before%20a%20huge%20challenge%20obstacle%2C%20deep%20navy%20and%20amber%20sports%20lighting%2C%20clean%20bold%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20energetic%20and%20fun&width=400&height=600&seq=poster-vr04&orientation=portrait',
    summary: '六位嘉宾每周接受一项极限任务，在体能与智慧的双重考验中争夺最终荣誉。',
    episodes: 22,
    updatedAt: '2024-12-10',
  },
  {
    id: 'island-survival',
    title: '孤岛余生',
    type: 'movie',
    year: 2020,
    region: '欧美',
    genres: ['冒险', '剧情'],
    director: 'Patrick Hale',
    actors: ['Ryan Blake', 'Emily Foster'],
    rating: 7.5,
    heat: 4120,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20survival%20movie%20poster%20of%20a%20lone%20figure%20on%20a%20rocky%20island%20shore%20facing%20a%20vast%20stormy%20sea%2C%20deep%20navy%20and%20cold%20amber%20tones%2C%20moody%20soft%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20epic%20and%20dramatic&width=400&height=600&seq=poster-mv09&orientation=portrait',
    summary: '一场海难后，一名男子独自困在荒岛，用求生意志与未知的孤独展开漫长博弈。',
    updatedAt: '2020-06-12',
  },
  {
    id: 'sword-rivers',
    title: '剑影江湖',
    type: 'movie',
    year: 2023,
    region: '大陆',
    genres: ['武侠', '动作'],
    director: '古长风',
    actors: ['楚天阔', '柳依依', '风无痕'],
    rating: 8.0,
    heat: 7020,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20wuxia%20movie%20poster%20of%20a%20swordsman%20on%20a%20bamboo%20forest%20cliff%20with%20drifting%20mist%2C%20deep%20navy%20and%20jade%20amber%20tones%2C%20ethereal%20soft%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20graceful%20and%20detailed&width=400&height=600&seq=poster-mv10&orientation=portrait',
    summary: '一柄失传的断剑重出江湖，两名立场对立的剑客被迫携手，追寻江湖背后的惊天秘密。',
    updatedAt: '2023-07-18',
  },
  {
    id: 'soul-journey-night',
    title: '心灵奇旅夜',
    type: 'movie',
    year: 2024,
    region: '欧美',
    genres: ['动画', '奇幻'],
    director: 'Nina Park',
    actors: ['Leo Marsh', 'Ava Quinn'],
    rating: 8.6,
    heat: 8140,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20animated%20family%20movie%20poster%20of%20a%20glowing%20starry%20city%20of%20light%20with%20a%20small%20luminous%20soul%20figure%2C%20deep%20navy%20sky%20and%20warm%20amber%20glows%2C%20soft%20dreamy%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20whimsical%20and%20vivid&width=400&height=600&seq=poster-mv11&orientation=portrait',
    summary: '一个刚踏上人生的小灵魂意外落入人间，在一夜的奇旅中学会感受平凡生活里的光。',
    updatedAt: '2024-03-09',
  },
  {
    id: 'silent-testimony',
    title: '沉默证词',
    type: 'movie',
    year: 2025,
    region: '港台',
    genres: ['犯罪', '悬疑', '剧情'],
    director: '谭兆麟',
    actors: ['郭子铭', '何静文', '程朗'],
    rating: 8.2,
    heat: 7960,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20legal%20thriller%20movie%20poster%20of%20a%20lawyer%20standing%20in%20a%20dim%20courtroom%20with%20golden%20window%20light%2C%20deep%20navy%20and%20amber%20tones%2C%20minimal%20dark%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20serious%20and%20detailed&width=400&height=600&seq=poster-mv12&orientation=portrait',
    summary: '一桩没有目击者的凶案，一份始终沉默的证词，年轻律师必须在真相与正义之间做出抉择。',
    updatedAt: '2025-09-20',
  },
  {
    id: 'dawn-operation',
    title: '破晓行动',
    type: 'movie',
    year: 2024,
    region: '大陆',
    genres: ['动作', '犯罪'],
    director: '雷野',
    actors: ['高岩', '宁静姝', '冯超'],
    rating: 7.7,
    heat: 6340,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20action%20movie%20poster%20of%20an%20agent%20moving%20through%20a%20rainy%20harbor%20warehouse%20at%20dawn%2C%20deep%20navy%20and%20amber%20muzzle%20flash%20tones%2C%20moody%20dark%20background%2C%20gritty%20thriller%20poster%20art%2C%20highly%20detailed%2C%20no%20text%2C%20tense%20and%20dynamic&width=400&height=600&seq=poster-mv13&orientation=portrait',
    summary: '一次失败的缉毒行动后，卧底警员必须在身份暴露前完成最后的收网。',
    updatedAt: '2024-10-11',
  },
  {
    id: 'snow-vow',
    title: '雪国的约定',
    type: 'movie',
    year: 2022,
    region: '日韩',
    genres: ['爱情', '剧情'],
    director: '川岛悠人',
    actors: ['石原理沙', '中岛凉', '小林优'],
    rating: 7.9,
    heat: 4980,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20romance%20movie%20poster%20of%20two%20figures%20standing%20in%20a%20quiet%20snowy%20village%20at%20blue%20hour%2C%20deep%20navy%20winter%20tones%20with%20warm%20amber%20window%20light%2C%20soft%20minimal%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20poignant%20and%20serene&width=400&height=600&seq=poster-mv14&orientation=portrait',
    summary: '一场大雪封住了小镇，也封住了两个人多年未曾说出口的约定。',
    updatedAt: '2022-12-16',
  },
  {
    id: 'rebirth-code',
    title: '再生代码',
    type: 'movie',
    year: 2022,
    region: '欧美',
    genres: ['科幻', '悬疑'],
    director: 'Alan Pierce',
    actors: ['Derek Nolan', 'Sven Holm', 'Paula Reed'],
    rating: 7.6,
    heat: 5210,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20sci-fi%20poster%20of%20a%20human%20silhouette%20dissolving%20into%20streams%20of%20glowing%20data%20code%2C%20deep%20navy%20and%20amber%20digital%20glow%2C%20clean%20dark%20minimal%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20futuristic%20and%20detailed&width=400&height=600&seq=poster-mv15&orientation=portrait',
    summary: '一名程序员发现自己上传的意识副本开始拥有独立人格，并试图取代真实的他。',
    updatedAt: '2022-04-22',
  },
  {
    id: 'fireworks-world',
    title: '烟火人间',
    type: 'movie',
    year: 2021,
    region: '大陆',
    genres: ['剧情'],
    director: '苏怀民',
    actors: ['佟大川', '刘桂枝', '王海'],
    rating: 8.0,
    heat: 4360,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20drama%20movie%20poster%20of%20a%20warm%20street%20food%20stall%20glowing%20at%20night%20in%20an%20old%20town%2C%20deep%20navy%20evening%20and%20cozy%20amber%20lights%2C%20soft%20nostalgic%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20heartfelt%20and%20detailed&width=400&height=600&seq=poster-mv16&orientation=portrait',
    summary: '一个普通家庭的十年烟火日常，在琐碎与温暖之间，写尽了生活的重量。',
    updatedAt: '2021-11-03',
  },
  {
    id: 'ghost-train',
    title: '幽灵列车',
    type: 'movie',
    year: 2023,
    region: '欧美',
    genres: ['悬疑', '奇幻'],
    director: 'Marcus Bell',
    actors: ['Colin Reed', 'Hana Sato', 'Greg Owens'],
    rating: 7.4,
    heat: 5620,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20mystery%20poster%20of%20an%20old%20abandoned%20train%20emerging%20from%20dense%20fog%20on%20empty%20tracks%2C%20deep%20navy%20mist%20and%20amber%20lamp%20glow%2C%20eerie%20minimal%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20atmospheric%20and%20detailed&width=400&height=600&seq=poster-mv17&orientation=portrait',
    summary: '一列深夜准点出现的空列车，载着乘客通往他们最不愿面对的记忆深处。',
    updatedAt: '2023-10-27',
  },
  {
    id: 'shadow-reborn',
    title: '侠影重生',
    type: 'movie',
    year: 2020,
    region: '大陆',
    genres: ['武侠', '奇幻', '动作'],
    director: '东方曜',
    actors: ['萧寒', '云裳', '墨七'],
    rating: 7.5,
    heat: 4720,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20wuxia%20fantasy%20poster%20of%20a%20swordsman%20surrounded%20by%20floating%20glowing%20swords%20in%20dark%20mist%2C%20deep%20navy%20and%20amber%20jade%20glow%2C%20ethereal%20minimal%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20mystical%20and%20detailed&width=400&height=600&seq=poster-mv18&orientation=portrait',
    summary: '身死道消的一代剑客借他人之身重生，只为完成前世未尽的承诺。',
    updatedAt: '2020-09-15',
  },
  {
    id: 'long-night',
    title: '长夜未央',
    type: 'tv',
    year: 2025,
    region: '大陆',
    genres: ['悬疑', '犯罪', '剧情'],
    director: '郝立',
    actors: ['秦越', '夏清', '白舟', '江宁'],
    rating: 8.5,
    heat: 9340,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20crime%20series%20poster%20of%20a%20detective%20under%20a%20single%20streetlamp%20on%20an%20empty%20night%20street%2C%20deep%20navy%20darkness%20and%20cool%20amber%20glow%2C%20minimal%20moody%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20intense%20and%20detailed&width=400&height=600&seq=poster-tv09&orientation=portrait',
    summary: '跨越十二年的连环案再次出现，退休刑警被迫重返一线，与时间赛跑。',
    episodes: 24,
    updatedAt: '2025-10-08',
  },
  {
    id: 'shanghai-mist',
    title: '沪上烟云',
    type: 'tv',
    year: 2023,
    region: '大陆',
    genres: ['年代', '剧情'],
    director: '沈家树',
    actors: ['周佩瑜', '林博文', '陈曼'],
    rating: 8.2,
    heat: 7560,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20period%20drama%20poster%20of%20an%20elegant%20woman%20in%20a%201930s%20cheongsam%20before%20old%20Shanghai%20architecture%2C%20deep%20navy%20and%20muted%20amber%20sepia%20tones%2C%20soft%20minimal%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20refined%20and%20nostalgic&width=400&height=600&seq=poster-tv10&orientation=portrait',
    summary: '上世纪三十年代的上海，一个家族在时代洪流中的兴衰与坚守。',
    episodes: 42,
    updatedAt: '2023-09-19',
  },
  {
    id: 'white-echo',
    title: '白色回声',
    type: 'tv',
    year: 2023,
    region: '欧美',
    genres: ['剧情', '医疗'],
    director: 'Rebecca Stone',
    actors: ['Julia Hayes', 'Mark Lin', 'Sofia Rossi'],
    rating: 8.1,
    heat: 6810,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20medical%20drama%20poster%20of%20a%20doctor%20in%20a%20dim%20hospital%20corridor%20with%20soft%20window%20light%2C%20deep%20navy%20and%20clean%20amber%20tones%2C%20minimal%20clinical%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20serious%20and%20detailed&width=400&height=600&seq=poster-tv11&orientation=portrait',
    summary: '在一间急诊室里，一群医生在每个生死瞬间做出的抉择，定义了他们自己。',
    episodes: 14,
    updatedAt: '2023-06-14',
  },
  {
    id: 'secret-neighbor',
    title: '秘密花园的邻居',
    type: 'tv',
    year: 2022,
    region: '日韩',
    genres: ['悬疑', '爱情'],
    director: '朴世俊',
    actors: ['金智媛', '安在赫', '吴夏林'],
    rating: 7.8,
    heat: 6320,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20romance%20mystery%20poster%20of%20a%20lush%20overgrown%20garden%20behind%20an%20old%20house%20with%20one%20glowing%20window%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20soft%20dreamy%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20intimate%20and%20detailed&width=400&height=600&seq=poster-tv12&orientation=portrait',
    summary: '新搬来的女孩发现隔壁花园每到深夜都会亮灯，而主人似乎隐藏着不为人知的过去。',
    episodes: 16,
    updatedAt: '2022-08-24',
  },
  {
    id: 'jianghu-inn',
    title: '江湖客栈',
    type: 'tv',
    year: 2024,
    region: '大陆',
    genres: ['古装', '喜剧'],
    director: '钱满堂',
    actors: ['杜子腾', '柳如烟', '胡有才'],
    rating: 7.9,
    heat: 7020,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20costume%20comedy%20series%20poster%20of%20a%20lively%20ancient%20Chinese%20inn%20at%20night%20with%20warm%20lanterns%2C%20deep%20navy%20and%20cheerful%20amber%20tones%2C%20clean%20playful%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20fun%20and%20detailed&width=400&height=600&seq=poster-tv13&orientation=portrait',
    summary: '一间开在江湖要道的小客栈，每天迎来的客人都带着一个啼笑皆非的故事。',
    episodes: 30,
    updatedAt: '2024-08-08',
  },
  {
    id: 'beyond-border',
    title: '界线之外',
    type: 'tv',
    year: 2025,
    region: '欧美',
    genres: ['科幻', '悬疑', '剧情'],
    director: 'Nathan Wells',
    actors: ['Owen Blake', 'Tara Kim', 'Felix Bauer'],
    rating: 8.3,
    heat: 8420,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20sci-fi%20series%20poster%20of%20a%20vast%20glowing%20scientific%20facility%20at%20the%20edge%20of%20a%20desert%20horizon%2C%20deep%20navy%20night%20and%20amber%20artificial%20glow%2C%20minimal%20futuristic%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20expansive%20and%20detailed&width=400&height=600&seq=poster-tv14&orientation=portrait',
    summary: '边界禁区的研究站突然与外界失联，一支小队深入调查，却发现那里的时间线早已错乱。',
    episodes: 12,
    updatedAt: '2025-10-12',
  },
  {
    id: 'starlight-stage',
    title: '星光舞台',
    type: 'variety',
    year: 2025,
    region: '大陆',
    genres: ['音乐', '竞技'],
    director: '顾声远',
    actors: ['方澄', '黎夜', '许漾'],
    rating: 8.3,
    heat: 8120,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20music%20competition%20poster%20of%20a%20singer%20in%20a%20spotlight%20with%20floating%20light%20particles%20on%20a%20dark%20stage%2C%20deep%20navy%20and%20vibrant%20amber%20highlights%2C%20clean%20dramatic%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20electrifying%20and%20detailed&width=400&height=600&seq=poster-vr05&orientation=portrait',
    summary: '来自不同风格赛道的新生代歌手，用一场场现场演绎争夺年度舞台之王的称号。',
    episodes: 16,
    updatedAt: '2025-09-25',
  },
  {
    id: 'travel-together',
    title: '一起去旅行',
    type: 'variety',
    year: 2024,
    region: '大陆',
    genres: ['真人秀', '生活'],
    director: '吴悠',
    actors: ['周可', '林小满', '程野', '安然'],
    rating: 7.6,
    heat: 6320,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20travel%20reality%20show%20poster%20of%20a%20camper%20van%20on%20a%20winding%20mountain%20road%20at%20sunset%2C%20deep%20navy%20dusk%20and%20warm%20amber%20sun%2C%20clean%20open%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20wanderlust%20and%20lively&width=400&height=600&seq=poster-vr06&orientation=portrait',
    summary: '四位好友开着一辆房车穿越山海，在旅途中重新认识彼此，也重新认识生活。',
    episodes: 12,
    updatedAt: '2024-10-30',
  },
  {
    id: 'food-adventure',
    title: '美食奇遇记',
    type: 'variety',
    year: 2023,
    region: '大陆',
    genres: ['美食', '真人秀'],
    director: '陈味',
    actors: ['王大厨', '苏甜', '李探'],
    rating: 7.8,
    heat: 5680,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20food%20show%20poster%20of%20steaming%20signature%20dishes%20on%20a%20rustic%20wooden%20table%20under%20warm%20light%2C%20deep%20navy%20background%20and%20appetizing%20amber%20glow%2C%20clean%20cozy%20composition%2C%20premium%20poster%20art%2C%20no%20text%2C%20delicious%20and%20detailed&width=400&height=600&seq=poster-vr07&orientation=portrait',
    summary: '跟着三位美食探员走遍城镇街巷，在每一道地方风味背后遇见真实的人情故事。',
    episodes: 20,
    updatedAt: '2023-11-12',
  },
  {
    id: 'comedy-rookies',
    title: '喜剧新星季',
    type: 'variety',
    year: 2022,
    region: '大陆',
    genres: ['喜剧', '真人秀'],
    director: '黄一笑',
    actors: ['阿逗', '张小帅', '毛毛'],
    rating: 7.5,
    heat: 5120,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20comedy%20competition%20poster%20of%20a%20lone%20microphone%20on%20a%20warmly%20lit%20stage%20with%20colorful%20bokeh%2C%20deep%20navy%20and%20playful%20amber%20accents%2C%20clean%20bold%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20cheerful%20and%20detailed&width=400&height=600&seq=poster-vr08&orientation=portrait',
    summary: '一群怀揣舞台梦的喜剧新人同台竞技，用最接地气的段子赢下属于他们的掌声。',
    episodes: 14,
    updatedAt: '2022-12-05',
  },
  {
    id: 'escape-night',
    title: '密室大逃脱夜',
    type: 'variety',
    year: 2025,
    region: '大陆',
    genres: ['竞技', '悬疑'],
    director: '孟星河',
    actors: ['罗铮', '叶蓝', '钟晓', '方舟'],
    rating: 8.0,
    heat: 7980,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20escape%20room%20show%20poster%20of%20a%20dim%20mysterious%20room%20with%20glowing%20clues%20and%20a%20locked%20door%2C%20deep%20navy%20shadows%20and%20amber%20accent%20light%2C%20clean%20tense%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20suspenseful%20and%20detailed&width=400&height=600&seq=poster-vr09&orientation=portrait',
    summary: '六位嘉宾被困在精心设计的巨型密室中，必须在天亮前解开层层谜题逃出生天。',
    episodes: 18,
    updatedAt: '2025-09-18',
  },
  {
    id: 'field-life',
    title: '田野生活家',
    type: 'variety',
    year: 2023,
    region: '大陆',
    genres: ['真人秀', '生活'],
    director: '田原',
    actors: ['沈宁静', '陆一航', '夏小满'],
    rating: 7.7,
    heat: 5460,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20lifestyle%20reality%20poster%20of%20a%20cozy%20countryside%20farmhouse%20surrounded%20by%20green%20fields%20at%20golden%20hour%2C%20deep%20navy%20shadows%20and%20warm%20amber%20sun%2C%20soft%20pastoral%20background%2C%20premium%20poster%20art%2C%20no%20text%2C%20peaceful%20and%20detailed&width=400&height=600&seq=poster-vr10&orientation=portrait',
    summary: '三位都市人搬进乡下小院，从零开始种菜养花，重新找回被城市弄丢的生活节奏。',
    episodes: 16,
    updatedAt: '2023-08-30',
  },
];